<pdf-viewer class="pdf-viewer-body" [src]="pdfSrc" [render-text]="true" [original-size]="false"
    style="width: 400px; height: 500px"></pdf-viewer>